var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return _c('div',{class:( _obj = {
	'hand': true
}, _obj[ 'is-color-' + _vm.props.color ] = true, _obj['is-open'] =  _vm.props.isOpen, _obj )},[_c('div',{staticClass:"hand--closed"}),_c('div',{staticClass:"hand--open"})])}
var staticRenderFns = []

export { render, staticRenderFns }